import { Layer } from "../../reducers";

export const getKeyData = (layer: Layer) => `${layer.id}.${layer.aggregateAttr}`;
